module.exports = __webpack_public_path__ + "static/media/pattern3.dd876a1b.png";